import {axiosGet} from "../../../../common/Helper/AxiosHelper";
import {SELECTABLE_SKILL_ZONE} from "../../../../tenant/Config/ApiUrl";

const state = {
    selectable: [],
    called: false
}

const actions = {
    getSelectableSkillZones({commit, state}) {
            commit('SET_CALLED', true);
            axiosGet(`${SELECTABLE_SKILL_ZONE}`).then(({data}) => {
                commit('SKILL_ZONE_LIST', data)
            });
    }
}

const mutations = {
    SKILL_ZONE_LIST(state, data) {
        state.selectable = data;
    },
    SET_CALLED(state, data) {
        state.called = data;
    }
}

export default {
    state,
    actions,
    mutations
}
